import { jsx } from "react/jsx-runtime";
import MuiToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import invariant from "tiny-warning";
function fieldToToggleButtonGroup({
  field: { onChange: _onChange, onBlur: fieldOnBlur, ...field },
  type,
  onChange,
  onBlur,
  form,
  ...props
}) {
  if (process.env.NODE_ENV !== "production") {
    invariant(
      type === "checkbox",
      `property type=checkbox is missing from field ${field.name}, this can caused unexpected behaviour`
    );
    if (!props.exclusive) {
      invariant(
        Array.isArray(field.value),
        `value for ${field.name} is not an array, this can caused unexpected behaviour`
      );
    }
  }
  return {
    onBlur: onBlur ?? function() {
      fieldOnBlur(field.name);
    },
    onChange: onChange ?? function(_event, newValue) {
      form.setFieldValue(field.name, newValue);
    },
    ...field,
    ...props
  };
}
function ToggleButtonGroup(props) {
  return /* @__PURE__ */ jsx(MuiToggleButtonGroup, { ...fieldToToggleButtonGroup(props) });
}
ToggleButtonGroup.displayName = "FormikMaterialUIToggleButtonGroup";
export {
  ToggleButtonGroup,
  fieldToToggleButtonGroup
};
//# sourceMappingURL=ToggleButtonGroup.js.map
